export default __webpack_public_path__ + "static/media/king-shark.e8c2dc6b.png";